import { jsx as o, jsxs as e } from "react/jsx-runtime";

import { useRef as r } from "react";

import { Table as n } from "react-aria-components";

import t from "../../utils/classNames/index.js";

import s from "./components/Body/index.js";

import i from "./components/Cell/index.js";

import m from "./components/Column/index.js";

import a from "./components/ColumnSorter/index.js";

import l from "./components/DummyRows/index.js";

import c from "./components/EmptyBody/index.js";

import p from "./components/Footer/index.js";

import d from "./components/Header/index.js";

import f from "./components/Pagination/index.js";

import u from "./components/Row/index.js";

import x from "./components/RowsPerPage/index.js";

import w from "./components/Settings/index.js";

import j from "./components/SkeletonCell/index.js";

import g from "./context/index.js";

import { COLOR_VARIANTS as y } from "../../constants/index.js";

import "react-loading-skeleton/dist/skeleton.css";

import { SCROLL_PADDING_BY_SPACING as h } from "./constants/index.js";

const S = ({model: s, className: i, children: m, containerClassName: a, wrapperClassName: l, variant: c = "solid", cellSpacing: p = "m", colorVariant: d = y.primary, rowSeparator: f = !0, disableAutoScroll: u = !1, prefix: x = null, footer: w = null, ...j}) => {
    const S = r(null);
    "production" !== process.env.NODE_ENV && j.onRowAction && 
    // TODO: link doc site when built out for this warning
    console.warn('[Warning]: use of "onRowAction" is discouraged. To consume contextual row data inside of your action, pass "onAction" to each row where rendered. Then you can supply the entire Row as an arg.');
    const v = h[p], C = {
        model: s,
        variant: c,
        cellSpacing: p,
        rowSeparator: f,
        colorVariant: d,
        scrollToTop: () => {
            u || S?.current?.scroll({
                top: 0,
                behavior: "instant"
            });
        }
    };
    return o(g.Provider, {
        value: C,
        children: e("div", {
            className: t("relative flex min-w-full flex-col", l),
            children: [ x, o("div", {
                ref: S,
                className: t("min-h-[400px] grow basis-0 overflow-auto", v, a),
                children: o(n, {
                    ...j,
                    className: t("typography-body !text-neutral min-w-full border-separate border-spacing-0", i),
                    children: m
                })
            }), w ]
        })
    });
};

S.Body = s, S.Cell = i, S.Column = m, S.ColumnSorter = a, S.DummyRows = l, S.EmptyBody = c, 
S.Footer = p, S.Header = d, S.Pagination = f, S.Row = u, S.RowsPerPage = x, S.Settings = w, 
S.SkeletonCell = j;

export { S as default };
//# sourceMappingURL=index.js.map
